const language = [
  {
    value: 'fi',
    label: 'application.language.fi'
  },
  {
    value: 'en',
    label: 'application.language.en'
  }
]

const lifeSituation = [
  {
    value: 'working',
    label: 'application.lifeSituation.working'
  },
  {
    value: 'studying',
    label: 'application.lifeSituation.studying'
  },
  {
    value: 'pension',
    label: 'application.lifeSituation.pension'
  },
  {
    value: 'other',
    label: 'application.lifeSituation.other'
  }
]

const movingWith = [
  {
    value: 'alone',
    label: 'application.movingWith.alone'
  },
  {
    value: 'asCouple',
    label: 'application.movingWith.asCouple'
  },
  {
    value: 'asFamily',
    label: 'application.movingWith.asFamily'
  },
  {
    value: 'asGroup',
    label: 'application.movingWith.asGroup'
  }
]

const pets = [
  {
    value: 'yes',
    label: 'application.pets.yes'
  },
  {
    value: 'no',
    label: 'application.pets.no'
  }
]

const depositPaymentMethod = [
  {
    value: 'money',
    label: 'application.depositPaymentMethod.money'
  },
  {
    value: 'kelaObligation',
    label: 'application.depositPaymentMethod.kelaObligation'
  },
  {
    value: 'rentalSecurityAccount',
    label: 'application.depositPaymentMethod.rentalSecurityAccount'
  },
  {
    value: 'other',
    label: 'application.depositPaymentMethod.other'
  }
]

const creditStatus = [
  {
    value: 'good',
    label: 'application.creditStatus.good'
  },
  {
    value: 'bad',
    label: 'application.creditStatus.bad'
  }
]

const status = [
  {
    value: '',
    label: ''
  },
  {
    value: 'created',
    label: 'created'
  },
  {
    value: 'accepted',
    label: 'accepted'
  },
  {
    value: 'showing',
    label: 'Showing with landlord'
  },
  {
    value: 'waitingForContract',
    label: 'Accepted and waiting for rent contract'
  },
  {
    value: 'tenant',
    label: 'Tenant'
  }
]

export {
  language,
  lifeSituation,
  movingWith,
  pets,
  depositPaymentMethod,
  creditStatus,
  status
}
